module.exports = __webpack_public_path__ + "img/wx_code.79d37f49.jpg";